export interface ImageProps {
  url: string;
  altTextKey: string;
}
/* eslint-disable-next-line */
export interface GymPartnersDataProps {
  titleKey: string;
  images: Array<ImageProps>;
}

export const commercialGymPartnersProps: GymPartnersDataProps = {
  titleKey: 'gymPartners.title',
  images: [
    {
      url: 'images/partners/anytimeFitnessLogo.png',
      altTextKey: 'gymPartners.gym.anytimeFitnessAltText',
    },
    {
      url: 'images/partners/crunchLogo.png',
      altTextKey: 'gymPartners.gym.crunchLogoAltText',
    },
    {
      url: 'images/partners/laFitnessLogo.png',
      altTextKey: 'gymPartners.gym.laFitnessAltText',
    },
    {
      url: 'images/partners/planetFitnessLogo.png',
      altTextKey: 'gymPartners.gym.planetFitnessAltText',
    },
    {
      url: 'images/partners/orangeTheoryLogo.png',
      altTextKey: 'gymPartners.gym.orangeTheoryAltText',
    },
    {
      url: 'images/partners/workoutAnytimeLogo.png',
      altTextKey: 'gymPartners.gym.workoutAnytimeAltText',
    },
    {
      url: 'images/partners/eosFitnessLogo.jpg',
      altTextKey: 'gymPartners.gym.eosFitnessAltText',
    },
  ],
};

export const governmentGymPartnersProps: GymPartnersDataProps = {
  titleKey: 'gymPartners.title',
  images: [
    {
      url: 'images/partners/ymcaLogo.png',
      altTextKey: 'gymPartners.gym.ymcaLogoAltText',
    },

    {
      url: 'images/partners/laFitnessLogo.png',
      altTextKey: 'gymPartners.gym.laFitnessAltText',
    },

    {
      url: 'images/partners/twentyfourHourFitnessLogo.png',
      altTextKey: 'gymPartners.gym.twentyfourHourFitnessAltText',
    },

    {
      url: 'images/partners/planetFitnessLogo.png',
      altTextKey: 'gymPartners.gym.planetFitnessAltText',
    },

    {
      url: 'images/partners/anytimeFitnessLogo.png',
      altTextKey: 'gymPartners.gym.anytimeFitnessAltText',
    },

    {
      url: 'images/partners/eosFitnessLogo.png',
      altTextKey: 'gymPartners.gym.eosFitnessAltText',
    },
  ],
};

export const newCommercialGymPartnersProps: GymPartnersDataProps = {
  titleKey: 'gymPartners.title',
  images: [
    {
      url: 'images/updated-gym-partners/clubPilates.png',
      altTextKey: 'gymPartners.gym.clubPilatesAltText',
    },
    {
      url: 'images/updated-gym-partners/crunch.svg',
      altTextKey: 'gymPartners.gym.crunchLogoAltText',
    },
    {
      url: 'images/updated-gym-partners/LA_Fitness.svg',
      altTextKey: 'gymPartners.gym.laFitnessAltText',
    },
    {
      url: 'images/updated-gym-partners/eosFitness.png',
      altTextKey: 'gymPartners.gym.eosFitnessAltText',
    },
    {
      url: 'images/updated-gym-partners/orangeTheory.svg',
      altTextKey: 'gymPartners.gym.orangeTheoryAltText',
    },
    {
      url: 'images/updated-gym-partners/F45.svg',
      altTextKey: 'gymPartners.gym.F45AltText',
    },
    {
      url: 'images/updated-gym-partners/pureBarre.svg',
      altTextKey: 'gymPartners.gym.pureBarreAltText',
    },
    {
      url: 'images/updated-gym-partners/snapFitness.svg',
      altTextKey: 'gymPartners.gym.snapFitnessAltText',
    },
    {
      url: 'images/updated-gym-partners/VASA.png',
      altTextKey: 'gymPartners.gym.VASAAltText',
    },
    {
      url: 'images/updated-gym-partners/yogasix.png',
      altTextKey: 'gymPartners.gym.yogasixAltText',
    },
  ],
};
